'use client'
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
import Blocto from './blocto.js';
import Dapper from './dapper.js';
import Lilico from './lilico.js';
export { FlowWalletConnector } from './FlowWalletConnector.js';
export { FlowWallet } from './wallet/FlowWallet.js';
export { isFlowWallet } from './wallet/isFlowWallet/isFlowWallet.js';

/* eslint-disable @typescript-eslint/no-unused-vars */
assertPackageVersion('@dynamic-labs/flow', version);
const FlowWalletConnectors = (props) => [Blocto, Dapper, Lilico];

export { FlowWalletConnectors };
